import { Component, computed, input, OnInit, output, signal } from "@angular/core"
import { FormsModule } from "@angular/forms"
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome"
import { FlatpickrDefaultsInterface, FlatpickrModule } from "angularx-flatpickr"

// Werte des zweiten SLA für den PATCH; Leeren = beide null (hawk#609)
export interface SlaExtraValue {
  sla_extra_label: string | null
  sla_extra_at: Date | string | null
}

// Inline-Formular für das zweite, manuelle SLA auf der Ticketseite (hawk#609).
// Bezeichnung und Termin sind nur gemeinsam gültig, daher ein Formular für beide Felder.
@Component({
  standalone: true,
  selector: "hawk-sla-extra-editor",
  templateUrl: "./sla-extra-editor.component.html",
  imports: [FormsModule, FlatpickrModule, FontAwesomeModule],
  host: {
    class: "flex flex-col gap-1",
  },
})
export class SlaExtraEditorComponent implements OnInit {
  // Länge der Bezeichnung, muss zur DB-Spalte tickets.sla_extra_label passen
  public static readonly MAX_LABEL_LENGTH = 15

  public label = input<string | null>(null)
  public at = input<string | null>(null)

  public saveClicked = output<SlaExtraValue>()
  public cancelClicked = output<void>()

  protected readonly maxLabelLength = SlaExtraEditorComponent.MAX_LABEL_LENGTH
  protected labelValue = signal("")
  protected atValue = signal<Date | string | null>(null)

  // Speichern nur, wenn beide Felder gefüllt sind (beide oder keins)
  protected canSave = computed(() => this.labelValue().trim().length > 0 && !!this.atValue())

  // Gleiche Picker-Konfiguration wie hawk-shared-edit-input im Modus "date"
  protected datePickerConfig: FlatpickrDefaultsInterface = {
    enableTime: true,
    convertModelValue: true,
    altInput: true,
    allowInput: true,
    altFormat: "d.m.Y H:i",
    dateFormat: "Y-m-d H:i",
    defaultHour: 10,
    defaultMinute: 0,
    minuteIncrement: 5,
    time24hr: true,
    enable: [{ from: new Date(1985, 1), to: new Date(new Date().getFullYear() + 50, 12) }],
  }

  ngOnInit(): void {
    this.labelValue.set(this.label() ?? "")
    this.atValue.set(this.at() ?? null)
  }

  protected save(): void {
    if (!this.canSave()) return

    this.saveClicked.emit({
      sla_extra_label: this.labelValue().trim(),
      sla_extra_at: this.atValue(),
    })
  }

  protected clear(): void {
    this.saveClicked.emit({ sla_extra_label: null, sla_extra_at: null })
  }

  protected cancel(): void {
    this.cancelClicked.emit()
  }
}
